module.exports = {"(^|\\.)espnfc\\.":"/football","(^|\\.)espncricinfo\\.":"/cricket"}


//////////////////
// WEBPACK FOOTER
// ../~/espn-url/hostPaths.json
// module id = 833
// module chunks = 0